var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivateOfficeIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 886,
    height: 531,
    viewBox: "0 0 886 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1530_868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.01 17.0471L361.959 12.4904C361.084 10.0751 360.074 7.711 358.933 5.40941L357.026 6.9493L358.536 4.61629C357.097 1.7843 355.965 0 355.965 0C355.965 0 350.05 9.31825 348.074 19.1841L351.859 25.0314L347.669 21.6484C347.52 22.7976 347.443 23.9551 347.439 25.114C347.439 36.7986 351.256 46.2707 355.965 46.2707C360.674 46.2707 364.491 36.7986 364.491 25.114C364.402 21.3966 363.745 17.7146 362.54 14.1964L359.01 17.0471Z",
    fill: "#9ECBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.884 27.1769L385.192 26.0397C386.282 23.7136 387.24 21.3278 388.061 18.8938L385.624 18.6345L388.341 18.0522C389.327 15.0324 389.788 12.9703 389.788 12.9703C389.788 12.9703 379.015 15.378 370.64 20.9573L369.181 27.7673L368.611 22.4134C367.693 23.1206 366.82 23.8848 365.997 24.7015C357.733 32.9637 353.733 42.36 357.062 45.6887C360.392 49.0173 369.79 45.0179 378.054 36.7557C380.621 34.0646 382.76 30.996 384.397 27.6569L379.884 27.1769Z",
    fill: "#9ECBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.823 72.3901C369.514 73.1773 356.102 72.3444 341.834 72.3901V39.7304C354.407 41.6872 367.814 41.4862 381.823 39.7304V72.3901Z",
    fill: "#9BA7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.25 70.0934H210.383V78.7469H520.25V70.0934Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.015 27.7426H450.492V73.2549H496.015V27.7426Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.91 36.8451H459.597V64.1525H486.91V36.8451Z",
    fill: "#9BA7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.503 46.0112L473.295 56.0398L479.086 66.0684H467.503H455.92L461.712 56.0398L467.503 46.0112Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.566 47.9275L483.358 57.9561L489.149 67.9847H477.566H465.983L471.775 57.9561L477.566 47.9275Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.639 44.9894C483.492 44.9894 484.994 43.4879 484.994 41.6358C484.994 39.7837 483.492 38.2823 481.639 38.2823C479.787 38.2823 478.285 39.7837 478.285 41.6358C478.285 43.4879 479.787 44.9894 481.639 44.9894Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.779 27.7426H220.256V73.2549H265.779V27.7426Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.674 36.8451H229.36V64.1525H256.674V36.8451Z",
    fill: "#9BA7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.267 46.0112L243.058 56.0398L248.85 66.0684H237.267H225.684L231.475 56.0398L237.267 46.0112Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.33 47.9275L253.121 57.9561L258.912 67.9847H247.33H235.747L241.538 57.9561L247.33 47.9275Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.403 44.9894C253.255 44.9894 254.757 43.4879 254.757 41.6358C254.757 39.7837 253.255 38.2823 251.403 38.2823C249.55 38.2823 248.048 39.7837 248.048 41.6358C248.048 43.4879 249.55 44.9894 251.403 44.9894Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.774 207.092L131.723 202.535C130.848 200.12 129.838 197.756 128.697 195.454L126.79 196.994L128.3 194.661C126.861 191.829 125.729 190.045 125.729 190.045C125.729 190.045 119.814 199.363 117.838 209.229L121.622 215.076L117.433 211.693C117.284 212.843 117.207 214 117.203 215.159C117.203 226.843 121.02 236.316 125.729 236.316C130.437 236.316 134.254 226.843 134.254 215.159C134.166 211.441 133.508 207.759 132.304 204.241L128.774 207.092Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.647 217.222L154.956 216.085C156.045 213.758 157.003 211.373 157.824 208.939L155.387 208.679L158.105 208.097C159.09 205.077 159.551 203.015 159.551 203.015C159.551 203.015 148.779 205.423 140.403 211.002L138.944 217.812L138.374 212.458C137.456 213.165 136.583 213.93 135.76 214.746C127.496 223.009 123.496 232.405 126.825 235.734C130.155 239.062 139.553 235.063 147.817 226.801C150.384 224.109 152.523 221.041 154.16 217.702L149.647 217.222Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.586 262.435C139.277 263.222 125.865 262.389 111.597 262.435V229.775C124.17 231.732 137.577 231.531 151.586 229.775V262.435Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.037 272.686H493.851V488.158H660.037V272.686Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.421 283.935H146.765V488.158H155.421V283.935Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.037 257.975H68V275.282H660.037V257.975Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.749 275.282H142.438V292.589H159.749V275.282Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.036 285.233L589.062 289.128H564.826L563.366 285.233H501.641V325.04H652.247V285.233H590.036Z",
    fill: "#687B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.036 335.424L589.062 339.317H564.826L563.366 335.424H501.641V375.23H652.247V335.424H590.036Z",
    fill: "#687B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.036 385.614L589.062 389.508H564.826L563.366 385.614H501.641V425.42H652.247V385.614H590.036Z",
    fill: "#687B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.036 435.805L589.062 439.699H564.826L563.366 435.805H501.641V475.611H652.247V435.805H590.036Z",
    fill: "#687B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 261H338L339.728 233H387.271L389 261Z",
    fill: "#FFA91F",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.393 107.796H266.211C264.834 107.796 263.513 108.343 262.539 109.317C261.565 110.291 261.018 111.611 261.018 112.988V231.974H466.586V112.988C466.586 111.611 466.039 110.291 465.065 109.317C464.091 108.343 462.77 107.796 461.393 107.796Z",
    fill: "#FFA91F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.018 212.111V231.582C261.018 232.959 261.565 234.279 262.539 235.253C263.513 236.227 264.834 236.774 266.211 236.774H461.393C462.77 236.774 464.091 236.227 465.065 235.253C466.039 234.279 466.586 232.959 466.586 231.582V212.111H261.018Z",
    fill: "#FFA91F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.632 118.613H271.404V222.455H456.632V118.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.286 486.86C784.37 488.07 763.758 486.79 741.832 486.86V436.67C761.153 439.677 781.757 439.368 803.286 436.67V486.86Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.722 441.176H769.529L771.26 339.751H772.991L774.722 441.176Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.093 441.862H792.899L794.63 340.436H796.361L798.093 441.862Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.949 441.862H748.756L750.487 340.436H752.218L753.949 441.862Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.05 274.849L787.434 261.896C784.947 255.03 782.076 248.31 778.833 241.767L773.412 246.144L777.704 239.512C773.613 231.462 770.395 226.39 770.395 226.39C770.395 226.39 753.581 252.878 747.964 280.924L758.722 297.546L746.813 287.929C746.388 291.196 746.17 294.487 746.159 297.781C746.159 330.996 757.01 357.923 770.395 357.923C783.779 357.923 794.63 330.996 794.63 297.781C794.63 287.484 792.3 276.711 789.086 266.745L779.05 274.849Z",
    fill: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.42 276.58L810.804 263.627C808.317 256.761 805.446 250.04 802.203 243.498L796.782 247.875L801.074 241.243C796.983 233.193 793.765 228.12 793.765 228.12C793.765 228.12 776.951 254.609 771.334 282.655L782.092 299.277L770.183 289.66C769.758 292.927 769.54 296.217 769.529 299.512C769.529 332.727 780.38 359.654 793.765 359.654C807.15 359.654 818 332.727 818 299.512C818 289.215 815.67 278.442 812.456 268.476L802.42 276.58Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.277 276.58L766.661 263.627C764.174 256.761 761.303 250.04 758.06 243.498L752.639 247.875L756.931 241.243C752.84 233.193 749.622 228.12 749.622 228.12C749.622 228.12 732.808 254.609 727.191 282.655L737.949 299.277L726.04 289.66C725.615 292.927 725.397 296.217 725.386 299.512C725.386 332.727 736.237 359.654 749.622 359.654C763.007 359.654 773.857 332.727 773.857 299.512C773.857 289.215 771.527 278.442 768.313 268.476L758.277 276.58Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.414 147.925H331.471V150.791H381.414V147.925Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.594 158.381H331.471V161.247H408.594V158.381Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.325 168.231H331.471V171.097H394.325V168.231Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.164 178.044H331.471V180.91H368.164V178.044Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.85 187.857H331.471V190.724H386.85V187.857Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.823 146.906H308.708V153.02H314.823V146.906Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.823 156.757H308.708V162.871H314.823V156.757Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.823 166.607H308.708V172.721H314.823V166.607Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.823 176.457H308.708V182.572H314.823V176.457Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.823 186.308H308.708V192.422H314.823V186.308Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.051 142.499H421.842C420.054 132.162 420.054 121.595 421.842 111.258H448.051C445.098 121.462 445.098 132.294 448.051 142.499Z",
    fill: "#3D9799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.351 185.252L246.569 182.624C242.454 182.629 238.39 181.72 234.67 179.962C230.95 178.204 227.668 175.641 225.061 172.459C222.453 169.277 220.586 165.555 219.594 161.563C218.602 157.571 218.51 153.408 219.325 149.376C219.313 139.756 223.124 130.525 229.92 123.713C236.716 116.902 245.939 113.069 255.562 113.057C265.184 113.045 274.418 116.855 281.231 123.649C288.043 130.443 291.878 139.665 291.89 149.285C298.003 170.554 278.856 190.493 257.351 185.252Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.128 189.044C283.852 189.044 295.787 177.111 295.787 162.391C295.787 147.671 283.852 135.738 269.128 135.738C254.405 135.738 242.469 147.671 242.469 162.391C242.469 177.111 254.405 189.044 269.128 189.044Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.742 176.297C251.742 176.297 243.628 204.109 238.991 206.427C234.355 208.744 276.083 212.221 276.083 212.221C276.083 212.221 274.924 185.568 277.242 183.25C279.56 180.932 251.742 176.297 251.742 176.297Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.469 347.804C293.469 347.804 345.629 343.169 352.584 360.551C359.538 377.934 347.947 481.07 347.947 481.07H325.924V396.475C325.924 396.475 232.022 369.79 232.022 360.519C232.022 351.248 293.469 347.804 293.469 347.804Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.47 476.435L356.061 481.07C356.061 481.07 369.97 479.911 364.175 490.34C362.516 493.368 360.195 495.982 357.385 497.989C354.576 499.995 351.35 501.342 347.947 501.929C347.947 501.929 325.924 510.041 324.765 501.929C323.606 493.817 330.561 477.593 330.561 477.593L344.47 476.435Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.492 347.804C264.492 347.804 316.651 343.169 323.606 360.551C330.561 377.934 318.97 481.07 318.97 481.07H296.947V396.475C296.947 396.475 230.291 381.039 230.291 371.768C230.291 367.413 225.749 345.279 233.753 340.616C242.787 335.353 264.492 347.804 264.492 347.804Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.492 476.435L327.083 481.07C327.083 481.07 340.992 479.911 335.197 490.34C333.538 493.368 331.217 495.982 328.408 497.989C325.598 499.995 322.372 501.342 318.97 501.929C318.97 501.929 296.947 510.041 295.788 501.929C294.628 493.817 301.583 477.593 301.583 477.593L315.492 476.435Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.151 202.95L274.984 206.735C280.36 207.32 285.414 209.587 289.424 213.214C293.434 216.842 296.195 221.643 297.313 226.933L310.856 291.021C310.856 291.021 315.492 354.757 306.219 358.234C296.947 361.71 284.196 344.328 266.81 346.645C249.423 348.963 226.821 354.178 226.821 354.178C226.821 354.178 223.232 240.093 222.764 230.762C221.829 212.108 240.151 202.95 240.151 202.95Z",
    fill: "#0D7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.662 351.115L336.963 359.535C336.963 359.535 362.618 355.855 361.817 364.87C361.016 373.885 333.012 372.143 333.012 372.143L315.778 361.527L322.662 351.115Z",
    fill: "#CDD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.382 140.713C226.893 140.713 234.603 133.005 234.603 123.497C234.603 113.988 226.893 106.28 217.382 106.28C207.872 106.28 200.162 113.988 200.162 123.497C200.162 133.005 207.872 140.713 217.382 140.713Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.272 114.241C233.27 111.695 232.702 109.18 231.611 106.879C230.519 104.578 228.93 102.548 226.958 100.935C224.987 99.3228 222.681 98.1678 220.209 97.5537C217.737 96.9397 215.159 96.8819 212.662 97.3845C214.866 96.3435 217.265 95.7822 219.702 95.7376C222.138 95.6931 224.556 96.1663 226.796 97.126C229.036 98.0858 231.047 99.5101 232.695 101.305C234.344 103.1 235.592 105.224 236.357 107.537C237.123 109.85 237.389 112.299 237.137 114.723C236.885 117.146 236.121 119.488 234.896 121.595C233.671 123.701 232.012 125.523 230.03 126.94C228.048 128.358 225.787 129.338 223.398 129.817C226.353 128.425 228.85 126.222 230.599 123.464C232.347 120.705 233.274 117.507 233.272 114.241Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.046 124.006L271.262 119.732L289.116 130.92C293.506 133.67 297.014 137.621 299.226 142.305C301.437 146.989 302.258 152.208 301.592 157.344L283.711 152.813L279.707 142.775L274.938 150.59L250.003 182.67L236.004 173.758L223.523 154.204L248.046 124.006Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.164 212.808L278.755 207.013C278.755 207.013 303.096 210.49 307.733 226.714C312.369 242.937 333.233 355.344 333.233 355.344L313.528 364.615L285.71 296.244L267.164 212.808Z",
    fill: "#0D7D80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.031 258.408L288.632 303.427L309.204 353.987L308.491 355.737L283.955 304.271L277.031 258.408Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.472 506.679L186.381 505.27L226.013 387.58L231.742 389.553L190.472 506.679Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.949 506.679L346.041 505.27L306.409 387.58L300.681 389.553L341.949 506.679Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.206 530.985L262.533 531L263.878 393.423L257.819 393.402L258.206 530.985Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.455 318.427L192.327 366.394C193.989 373.112 197.45 379.25 202.338 384.149C207.227 389.048 213.358 392.523 220.073 394.201C253.179 402.476 287.841 402.253 320.838 393.552L338.562 388.879C348.86 386.164 356.605 377.321 357.337 366.698C357.634 362.943 356.954 359.174 355.363 355.759C355.294 355.612 355.224 355.466 355.154 355.322C352.843 350.575 349.277 346.551 344.842 343.684C340.408 340.817 335.274 339.218 329.995 339.058L311.22 338.452L242.841 308.165C242.841 308.165 219.324 296.223 199.991 294.886C187.223 294.003 177.382 306.006 180.455 318.427Z",
    fill: "#6EB1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.284 167.546H529.771V259.273H597.284V167.546Z",
    fill: "#9BA7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.495 178.13H537.562V248.689H589.495V178.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.163 196.594H558.001V199.461H583.163V196.594Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.009 195.008H543.893V201.122H550.009V195.008Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.163 208.709H558.001V211.576H583.163V208.709Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.009 207.123H543.893V213.237H550.009V207.123Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.163 220.824H558.001V223.69H583.163V220.824Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.009 219.238H543.893V225.352H550.009V219.238Z",
    fill: "#042325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.124 172.738C566.124 171.304 564.962 170.142 563.528 170.142C562.094 170.142 560.931 171.304 560.931 172.738C560.931 174.172 562.094 175.334 563.528 175.334C564.962 175.334 566.124 174.172 566.124 172.738Z",
    fill: "#042325"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1530_868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 886,
    height: 531,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateOfficeIllustration);
export default __webpack_public_path__ + "static/media/PrivateOfficeIllustration.689c42e5d841c05bb6fd4b7e8361670b.svg";
export { ForwardRef as ReactComponent };